export const getAge = (birthDate) => {
  const birthDateObject = new Date(birthDate);
  const today = new Date();

  let age = today.getFullYear() - birthDateObject.getFullYear();
  const monthDiff = today.getMonth() - birthDateObject.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObject.getDate())) {
    age--;
  }

  return age;
};
